import BarChartIcon from "@material-ui/icons/BarChart";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ChatIcon from "@material-ui/icons/ChatOutlined";
import CodeIcon from "@material-ui/icons/Code";
import DashboardIcon from "@material-ui/icons/DashboardOutlined";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import FolderIcon from "@material-ui/icons/FolderOutlined";
import DashboardTwoToneIcon from "@material-ui/icons/DashboardTwoTone";
import GradeTwoTone from "@material-ui/icons/GradeTwoTone";
import ListAltIcon from "@material-ui/icons/ListAlt";
import LockOpenIcon from "@material-ui/icons/LockOpenOutlined";
import MailIcon from "@material-ui/icons/MailOutlined";
import PresentToAllIcon from "@material-ui/icons/PresentToAll";
import PeopleIcon from "@material-ui/icons/PeopleOutlined";
import PersonIcon from "@material-ui/icons/PersonOutlined";
import ReceiptIcon from "@material-ui/icons/ReceiptOutlined";
import SettingsIcon from "@material-ui/icons/SettingsOutlined";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import NoteIcon from "@material-ui/icons/Note";
import AddBoxIcon from "@material-ui/icons/AddBox";
import DirectionsBoatIcon from "@material-ui/icons/DirectionsBoat";
import AccessibilityIcon from "@material-ui/icons/Accessibility";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import ScoreIcon from "@material-ui/icons/Score";
import SyncAltIcon from "@material-ui/icons/SyncAlt";

var iconsMap = {
  BarChartIcon: BarChartIcon,
  CalendarTodayIcon: CalendarTodayIcon,
  ChatIcon: ChatIcon,
  CodeIcon: CodeIcon,
  DashboardIcon: DashboardIcon,
  ErrorIcon: ErrorIcon,
  FolderIcon: FolderIcon,
  DashboardTwoToneIcon: DashboardTwoToneIcon,
  GradeTwoTone: GradeTwoTone,
  ListAltIcon: ListAltIcon,
  LockOpenIcon: LockOpenIcon,
  MailIcon: MailIcon,
  PresentToAllIcon: PresentToAllIcon,
  PeopleIcon: PeopleIcon,
  PersonIcon: PersonIcon,
  ReceiptIcon: ReceiptIcon,
  SettingsIcon: SettingsIcon,
  ViewModuleIcon: ViewModuleIcon,
  EqualizerIcon: EqualizerIcon,
  NoteIcon: NoteIcon,
  AddBoxIcon: AddBoxIcon,
  AccessibilityIcon: AccessibilityIcon,
  DirectionsBoatIcon: DirectionsBoatIcon,
  TrendingUpIcon: TrendingUpIcon,
  ScoreIcon: ScoreIcon,
  SyncAltIcon: SyncAltIcon,
};

export default [
  {
    label: "Navigation menu",
    label_en: "Navigation menu",
    label_fr: "Menu de navigation",
    content: JSON.parse(
      `[
  {
    "label": "Tableau De Bord",
    "label_en": "Dashboard",
    "label_fr": "Tableau De Bord",
    "icon": "DashboardTwoToneIcon",
    "description": "This is a dashboard page example built using this template.",
    "to": "/DashboardShipper"
  },

  {
    "label": "Statistiques",
    "label_en": "Statistics",
    "label_fr": "Statistiques",
    "icon": "EqualizerIcon",
    "description": "This is a dashboard page example built using this template.",
    "content": [
    {
        "label": "Statistiques_ot",
      "label_en": "ECTN",
      "label_fr": "BESC",
      "icon": "NoteIcon",
      "description": "This is a dashboard page example built using this template.",
      "to": "/Statistiques"
        },
        {
        "label": "Statistiques_chargeur",
      "label_en": "ECTN",
      "label_fr": "BESC",
      "icon": "NoteIcon",
      "description": "This is a dashboard page example built using this template.",
      "to": "/Statistiquebesc"
        },

        {
        "label": "Statistiques_cncc",
        "label_en": "ECTN",
        "label_fr": "BESC",
        "icon": "NoteIcon",
        "description": "This is a dashboard page example built using this template.",
        "to": "/Statistiquebescoperation"
        },
         {
        "label": "Statistiques_perf",
        "label_en": "Perfomances",
        "label_fr": "Perfomances",
        "icon": "ScoreIcon",
        "description": "This is a dashboard page example built using this template.",
        "to": "/Performances"
        },
         {
        "label": "Mouvement_chargeur",
      "label_en": "Credit Movements",
      "label_fr": "Mouvements Crédit",
      "icon": "TrendingUpIcon",
      "description": "This is a dashboard page example built using this template.",
      "to": "/Mouvementbesc"
        },

        {
        "label": "Mouvement_cncc",
        "label_en": "Credit Movements",
        "label_fr": "Mouvements Crédit",
        "icon": "TrendingUpIcon",
        "description": "This is a dashboard page example built using this template.",
        "to": "/Mouvementbescoperation"
        },
         {
        "label": "Audit",
        "label_en": "Audit",
        "label_fr": "Audit",
        "icon": "SyncAltIcon",
        "description": "This is a dashboard page example built using this template.",
        "to": "/Reconciliation"
        }
    ]
  },
   
  {
    "label": "HelpDesk",
    "label_en": "HelpDesk",
    "label_fr": "HelpDesk",
    "icon": "AccessibilityIcon",
    "content": [
      {
        "label": "Chargeur",
        "label_en": "Shipper",
        "label_fr": "Chargeur",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Chargeur"
      },
      {
        "label": "CodeSH",
        "label_en": "SHCode",
        "label_fr": "CodeSH",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/CodeSH"
      },
      {
        "label": "Devise",
        "label_en": "Currency",
        "label_fr": "Devise",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Devise"
      },
      {
        "label": "Fournisseur",
        "label_en": "Foreign Shipper",
        "label_fr": "Fournisseur",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Fournisseur"
      },
      {
        "label": "Incoterm",
        "label_en": "Incoterm",
        "label_fr": "Incoterm",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Incoterm"
      },
      {
        "label": "Marque",
        "label_en": "Brand",
        "label_fr": "Marque",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Marque"
      },
      {
        "label": "Modèle",
        "label_en": "Model",
        "label_fr": "Modèle",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Modele"
      },
      {
        "label": "Navire",
        "label_en": "Vessel",
        "label_fr": "Navire",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Navire"
      },
      {
        "label": "Pays",
        "label_en": "Country",
        "label_fr": "Pays",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Pays"
      },
      {
        "label": "Port",
        "label_en": "Port",
        "label_fr": "Port",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Port"
      },

      {
        "label": "Transporteur",
        "label_en": "Carrier",
        "label_fr": "Transporteur",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Transporteur"
      },
      {
        "label": "Ville",
        "label_en": "Town",
        "label_fr": "Ville",
        "description":
          "This is a dashboard page example built using this template.",
        "to": "/Ville"
      }
    ]
  },
  {
    "label": "BESC",
    "label_en": "ECTN",
    "label_fr": "BESC",
    "icon": "NoteIcon",
    "content": [
      {
        "label": "Liste des BESCs",
        "label_en": "List of ECTNs",
        "label_fr": "Liste des BESCs",
        "description": "Tableau affichant la liste des BESCs enregistrés",
        "to": "/Listebesc"
      },
         {
        "label": "BESC Import",
        "label_en": "ECTNs in processing",
        "label_fr": "BESC Import",
        "description": "Tableau affichant la liste des BESCs import enregistrés",
        "to": "/Listebesc/import"
      },
       {
        "label": "BESC Regul",
        "label_en": "Regularization ECTNs in processing",
        "label_fr": "BESC Regul",
        "description": "Tableau affichant la liste des BESCs regul enregistrés",
        "to": "/Listebesc/regule"
      },
       {
        "label": "BESC Transit",
        "label_en": "Transit ECTNs in processing",
        "label_fr": "BESC Transit",
        "description": "Tableau affichant la liste des BESCs transit enregistrés",
        "to": "/Listebesc/transit"
      },
       {
        "label": "BESC Export",
        "label_en": "Export ECTNs in processing",
        "label_fr": "BESC Export",
        "description": "Tableau affichant la liste des BESCs export enregistrés",
        "to": "/Listebesc/export"
      },
      {
        "label": "Mes BESCs",
        "label_en": "My ECTNs",
        "label_fr": "Mes BESCs",
        "description": "Tableau affichant la liste des BESCs enregistrés",
        "to": "/Listebesc"
      },
      {
        "label": "Historique des BESCs",
        "label_en": "ECTN History",
        "label_fr": "Historique des BESCs",
        "description": "Tableau affichant l'historique des BESCs traités",
        "to": "/Historiquebesc"
      },

       {
        "label": "Redressements",
        "label_en": "Redressing",
        "label_fr": "Redressements",
        "description": "Tableau affichant la liste des BESCs en attente de redressement",
        "to": "/Listeredressement"
      },
       {
        "label": "Exonerations",
        "label_en": "Exonerations",
        "label_fr": "Exonérations",
        "description": "Tableau affichant la liste des BESCs en attente d'exoneration",
        "to": "/Listeexoneration"
      },
      {
        "label": "Annulations",
        "label_en": "Cancellations",
        "label_fr": "Annulations",
        "description": "Tableau affichant la liste des BESCs en attente d'annulation",
        "to": "/Listeannulation"
      },
      {
        "label": "Tous les BESCs",
        "label_en": "All ECTNs",
        "label_fr": "Tous les BESCs",
        "description": "Tableau affichant tous les BESCs de la société",
        "to": "/Listebescsociete"
      },
      {
        "label": "Créer un BESC",
        "label_en": "Create an ECTN",
        "label_fr": "Créer un BESC",
        "icon": "AddBoxIcon",
        "content": [
          {
            "label": "Maritime",
            "label_en": "Maritime",
            "label_fr": "Maritime",
            "icon": "DirectionsBoatIcon",
            "content": [
              {
                "label": "Import",
                "label_en": "Import",
                "label_fr": "Import",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/import",
                "origin": "Maritime"
              },
              {
                "label": "Regule",
                "label_en": "Regule",
                "label_fr": "Regule",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/regule",
                "origin": "Maritime"
              },
              {
                "label": "Export",
                "label_en": "Export",
                "label_fr": "Export",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/export",
                "origin": "Maritime"
              },
               {
                "label": "Transit",
                "label_en": "Transit",
                "label_fr": "Transit",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/transit",
                "origin": "Maritime"
              }
            ]
          },
          {
            "label": "Aérien",
            "label_en": "Aerial",
            "label_fr": "Aérien",
            "icon": "DashboardTwoToneIcon",
            "content": [
              {
                "label": "Import",
                "label_en": "Import",
                "label_fr": "Import",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/aerien/import",
                "origin": "Aérien"
              },  
              {
                "label": "Regule",
                "label_en": "Regule",
                "label_fr": "Regule",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/regule",
                "origin": "Maritime"
              },
              {
                "label": "Export",
                "label_en": "Export",
                "label_fr": "Export",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/aerien/export",
                "origin": "Aérien"
              },
               {
                "label": "Transit",
                "label_en": "Transit",
                "label_fr": "Transit",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/transit",
                "origin": "Maritime"
              }
            ]
          },
          {
            "label": "Terrestre",
            "label_en": "Terrestrial",
            "label_fr": "Terrestre",
            "icon": "DashboardTwoToneIcon",
            "content": [
              {
                "label": "Import",
                "label_en": "Import",
                "label_fr": "Import",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/terrestre/import",
                "origin": "Terrestre"
              },
               {
                "label": "Regule",
                "label_en": "Regule",
                "label_fr": "Regule",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/regule",
                "origin": "Maritime"
              },
              {
                "label": "Export",
                "label_en": "Export",
                "label_fr": "Export",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/terrestre/export",
                "origin": "Terrestre"
              },
               {
                "label": "Transit",
                "label_en": "Transit",
                "label_fr": "Transit",
                "description": "Formulaire de création du BESC",
                "to": "/Creation/maritime/transit",
                "origin": "Maritime"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "label": "Facturation",
    "label_en": "Billing",
    "label_fr": "Facturation",
    "icon": "ReceiptIcon",
    "content": [
      {
        "label": "Approvisionnement",
        "label_en": "Funding",
        "label_fr": "Approvisionnement",
        "description": "Résumé des transactions",
        "to": "/Approvisionnement"
      },
      {
        "label": "Liste des demandes d'approvisionnement",
        "label_en": "List of account funding requests",
        "label_fr": "Liste des demandes d'approvisionnement",
        "description": "Formulaire de recharge des comptes",
        "to": "/Listeapprovisionnement"
      },
      {
        "label": "Liste des redressements",
        "label_en": "List of redressings",
        "label_fr": "Liste des redressements",
        "description": "Formulaire de recharge des comptes",
        "to": "/Listingredressement"
      },
      {
        "label": "Débit/crédit manuel d'un compte",
        "label_en": "Manual account debit/credit",
        "label_fr": "Débit/crédit manuel d'un compte",
        "description": "Formulaire de recharge des comptes",
        "to": "/Mouvementmanuel"
      }
    ]
  },
  {
    "label": "Configuration",
    "label_en": "Configuration",
    "label_fr": "Configuration",
    "icon": "SettingsIcon",
    "content": [
    
      {
        "label": "Gestion des sous comptes",
        "label_en": "Sub account management",
        "label_fr": "Gestion des sous comptes",
        "description": "Gestion des sous comptes",
        "to": "/gestionDesComptes"
      }
     

    ]
  }
 
]`,
      (key, value) => {
        if (key === "icon") {
          return iconsMap[value];
        } else {
          return value;
        }
      },
    ),
  },
];
